import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../flux';
import { images, texts, relacionamentos } from '../../settings';
import { DelayLink, SliderText } from '../../components';

import './DentroDeCasa.scss';

class DentroDeCasa extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Dentro de casa - {texts.title}</title>
        </Helmet>

        <div
          className="dentro-de-casa-home page-gradient page-gradient--light-blue bg-gray bg-geral-dentre-de-casa"
          ref="dentro-de-casa-home"
        >
          <section className="dentro-de-casa-home-area page-gradient__header section-dentro-de-casa-header">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="page-header">
                      <DelayLink
                        to="/estrategias/nosso-ano"
                        className="button button--aylen button--white-to-light-blue button--border-medium button--size-m button--round-l button--text-thick"
                      >
                        Voltar
                      </DelayLink>

                      <h1 className="page-header__title">
                        Dentro de casa
                        <small>
                          Clique nos temas <br className="br_desk" />
                          para saber mais
                        </small>
                      </h1>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="dentro-de-casa-body">
            <div className="container container--large">
              <div className="dentro-de-casa-box">
                <div>
                  <div>
                    <div className="box-supervisao-e-compliance">
                      <div className="box-supervisao-margin-padding">
                        <Fade bottom>
                          <DelayLink
                            to="/iniciativa/programa-de-supervisao-digital"
                            className="card card--small card--light-blue"
                          >
                            <div className="card__content card__content--full">
                              <div className="card__content__header card__content__header--no-border">
                                <h2 className="title title--gray title--small texto-h2-dentro-de-casa">
                                  Supervisão <br className="br_desk" />
                                  Digital automatiza processos
                                </h2>
                              </div>
                            </div>
                          </DelayLink>
                        </Fade>
                      </div>
                      <div className="box-compliance-margin-padding">
                        <Fade bottom>
                          <DelayLink
                            to="/iniciativa/programa-de-compliance"
                            className="card card--small card--light-blue"
                          >
                            <div className="card__content card__content--full">
                              <div className="card__content__header card__content__header--no-border">
                                <h2 className="title title--gray title--small texto-h2-dentro-de-casa">
                                  Programa
                                  <br className="br_desk" />
                                  de Compliance é reformulado
                                </h2>
                              </div>
                            </div>
                          </DelayLink>
                        </Fade>
                      </div>
                    </div>
                    <div className="gestao-fornecedores-margin">
                      <Fade bottom>
                        <DelayLink
                          to="/iniciativa/gestao-de-fornecedores"
                          className="card card--small card--light-blue"
                        >
                          <div className="card__content card__content--full">
                            <div className="card__content__header card__content__header--no-border box-gestao-de-fornecedores">
                              <h2 className="title title--gray title--small texto-h2-dentro-de-casa">
                                Gestão de fornecedores <br /> assegura qualificação
                              </h2>
                              <img src={images.dentro_de_casa.computador} alt="Computador" />
                            </div>
                          </div>
                        </DelayLink>
                      </Fade>
                    </div>
                  </div>
                </div>
                <div className="box-reforco-na-comunicacao">
                  <Fade bottom>
                    <DelayLink to="/iniciativa/comunicacao-interna" className="card card--light-blue card--cultura">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title title--gray title--large texto-h2-dentro-de-casa">
                            Comunicação <br className="br_desk" /> interna ganha
                            <br className="br_desk" /> reforço
                          </h2>
                          <img src={images.dentro_de_casa.img_card_grande} className="image_cultura" />
                        </div>
                      </div>
                    </DelayLink>
                  </Fade>
                </div>
              </div>
            </div>

            <div className="container container--large">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <DelayLink to="/estrategias/para-o-mercado" className="card card--yellow card--para-o-mercado">
                      <div className="card__content card__content--full bg-sub-footer-dentro-de-casa">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title title--large title--center">Confira nossas ações para o mercado</h2>
                        </div>
                      </div>
                    </DelayLink>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="dentro-de-casa-footer-area governanca-footer">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade>
                    <div className="box-pill box-pill--green box-pill--center">
                      <div className="box-pill__content box-pill__content--full">
                        <div className="row">
                          <div className="col col-12 col--text texto-e-botao-center-footer-dentro-de-casa">
                            <h4>Veja os eventos de 2020</h4>
                            <DelayLink
                              to="/eventos"
                              className="button button--aylen button--white-to-green button--border-medium button--size-m button--round-l button--text-thick"
                            >
                              Saiba mais
                            </DelayLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { DentroDeCasa };
